// Universal lens toolbar search input (Phase 9) — the MAP's exact markup so
// both pages' search boxes are the same brick. Pages own the wiring.
import React from "react";
import { Loader2, Search } from "lucide-react";

const LensSearchInput = ({
  value,
  onChange,
  onKeyDown,
  placeholder = "Search",
  loading = false,
  right = null, // optional trailing node (match count, clear button, …)
}) => (
  <div className="flex h-8 min-w-[160px] flex-1 items-center gap-2 rounded-lg border border-mainDivider bg-mainButtonBg/30 px-3 text-xs text-mutedText transition-all duration-200 focus-within:border-velBlue/40 focus-within:shadow-[0_0_14px_rgba(14,165,233,0.14)]">
    <Search size={13} className="text-velBlue/80" />
    <input
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      className="w-full bg-transparent text-xs text-mainText placeholder:text-mutedText/70 outline-none"
    />
    {loading ? (
      <Loader2 size={13} className="shrink-0 animate-spin text-velBlue/80" />
    ) : (
      right
    )}
  </div>
);

export default LensSearchInput;
